var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEyeSlash(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.27 9.17981C20.98 8.71981 20.67 8.28981 20.35 7.88981C19.98 7.41981 19.28 7.37981 18.86 7.79981L15.86 10.7998C16.08 11.4598 16.12 12.2198 15.92 13.0098C15.57 14.4198 14.43 15.5598 13.02 15.9098C12.23 16.1098 11.47 16.0698 10.81 15.8498C10.81 15.8498 9.38001 17.2798 8.35001 18.3098C7.85001 18.8098 8.01001 19.6898 8.68001 19.9498C9.75001 20.3598 10.86 20.5698 12 20.5698C13.78 20.5698 15.51 20.0498 17.09 19.0798C18.7 18.0798 20.15 16.6098 21.32 14.7398C22.27 13.2298 22.22 10.6898 21.27 9.17981Z",
    fill: "#292D32"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.02 9.98014L9.98001 14.0201C9.47001 13.5001 9.14001 12.7801 9.14001 12.0001C9.14001 10.4301 10.42 9.14014 12 9.14014C12.78 9.14014 13.5 9.47014 14.02 9.98014Z",
    fill: "#292D32"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M18.25 5.75018L14.86 9.14018C14.13 8.40018 13.12 7.96018 12 7.96018C9.76 7.96018 7.96 9.77018 7.96 12.0002C7.96 13.1202 8.41 14.1302 9.14 14.8602L5.76 18.2502H5.75C4.64 17.3502 3.62 16.2002 2.75 14.8402C1.75 13.2702 1.75 10.7202 2.75 9.15018C3.91 7.33017 5.33 5.90018 6.91 4.92018C8.49 3.96018 10.22 3.43018 12 3.43018C14.23 3.43018 16.39 4.25018 18.25 5.75018Z",
    fill: "#292D32"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M14.86 12.0001C14.86 13.5701 13.58 14.8601 12 14.8601C11.94 14.8601 11.89 14.8601 11.83 14.8401L14.84 11.8301C14.86 11.8901 14.86 11.9401 14.86 12.0001Z",
    fill: "#292D32"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M21.77 2.22988C21.47 1.92988 20.98 1.92988 20.68 2.22988L2.23 20.6899C1.93 20.9899 1.93 21.4799 2.23 21.7799C2.38 21.9199 2.57 21.9999 2.77 21.9999C2.97 21.9999 3.16 21.9199 3.31 21.7699L21.77 3.30988C22.08 3.00988 22.08 2.52988 21.77 2.22988Z",
    fill: "#292D32"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEyeSlash);
export default __webpack_public_path__ + "static/media/eye-slash.053e299d18dc23dd8f15e2843a480fe7.svg";
export { ForwardRef as ReactComponent };